import React from 'react'
import ImageIcon from '../global/ImageIcon'
import useClipBoard from '../../hooks/useClipBoard'
import { toast } from 'react-toastify'
import ShareIcon from "../../assets/icons/ShareIcon";
import ExportIcon from "../../assets/icons/exportYellow.svg";
type Props = {
    htmlToImageConvertFn:()=>void
}

function ChartControlls({htmlToImageConvertFn}: Props) {
    const {copyText} = useClipBoard()
  return (
    <div className="flex justify-end items-center gap-4 pb-2 pr-4 z-50">
        <button className="px-4 py-4 rounded-md text-primary dark:text-white border border-primary bg-[#F3F3F3] flex gap-2 items-center" onClick={()=>{
          copyText(window.location.href.replace('/final','/final/share'),()=>{
            toast.success('link copied successfully')
          })
        }}>
          <ImageIcon Icon={ShareIcon} width={28} height={28} /> share as image
        </button>
        <button
          className="px-4 py-4 bg-primary rounded-md text-primaryYellow dark:text-whiteYellow flex gap-2 items-center "
          onClick={htmlToImageConvertFn}
        >
          <img loading="lazy" src={ExportIcon} alt="" width={28} height={28} />
          download as image
        </button>
      </div>
  )
}

export default ChartControlls